import { apiProxyRequest } from "Api/apiProxyRequest";
import { fetchAllPages } from "Api/utils";

import type { BillingAccountMappingsResponse } from "../types";

export const getUserBillingAccountsRequest = (userId: string) => {
  return fetchAllPages(
    apiProxyRequest<BillingAccountMappingsResponse>(
      `/users/${userId}/billing/accounts`
    )
  );
};
